import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
            const currentUser = this.authService.currentUserValue;
            if (currentUser) {
                if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
                    // role not authorised so redirect to home page
                    this.router.navigate(["/forbidden"]);
                    return false;
                }
                return true;
            }
            else{
                this.router.navigate(["/home"]);
                return false;
            }
    }
}
